import {AcceptedFileType, FileTypes} from "./file";

export const fileUploadData: FileTypes[] = [
  {
    id: 1,
    color: "primary",
    icon: "cloud-upload",
    description: "FileUploadFormWizard.resourceTypes.Document",
    type: AcceptedFileType.DOCUMENT,
    allowedExtensions: ['pdf', "docx", "odt", "txt", 'md']
  },
  {
    id: 2,
    color: "secondary",
    icon: "link-plus",
    description: "FileUploadFormWizard.resourceTypes.WebPage",
    type: AcceptedFileType.SCRAPER,
    allowedExtensions: null
  },
  {
    id: 3,
    color: "primary",
    icon: "photo-scan",
    description: "FileUploadFormWizard.resourceTypes.Multimedia",
    type: AcceptedFileType.MULTIMEDIA,
    allowedExtensions: [ "jpg", "jpeg", "png", "gif", "bmp", "tiff", "tif", "webp", "ico", "svg",
      "mp4", "avi", "mov", "wmv", "flv", "mkv", "webm", "3gp", "mpeg", "mpg", "m4v"]
  },
  {
    id: 4,
    color: "error",
    icon: "table",
    description: "FileUploadFormWizard.resourceTypes.Table",
    type: AcceptedFileType.TABLE,
    allowedExtensions: ["xls", "xlsx", "ods", "csv"]
  },
  {
    id: 5,
    color: "secondary",
    icon: "list-tree",
    description: "FileUploadFormWizard.resourceTypes.Organization",
    type: AcceptedFileType.ORGANIZATION,
    allowedExtensions: ["xls", "xlsx", "ods", "csv"]
  },
  {
    id: 6,
    color: "success",
    icon: "help-circle",
    description: "FileUploadFormWizard.resourceTypes.Q&A",
    type: AcceptedFileType.QA,
    allowedExtensions: ["xls", "xlsx"]
  },
  {
    id: 7,
    color: "warning",
    icon: "api",
    description: "FileUploadFormWizard.resourceTypes.WebServices",
    type: AcceptedFileType.API,
    allowedExtensions: null
  },
  {
    id: 8,
    color: "primary",
    icon: "affiliate",
    description: "FileUploadFormWizard.resourceTypes.Integration",
    type: AcceptedFileType.URL,
    allowedExtensions: null
  },
]
